import React from 'react';
import { AppliedReviewFilter, ReviewFilter } from '../../../types/reviews';
import styles from './reviewAppliedFiltersStyles.module.scss';

const AppliedProductReviewFilters = ({
  filters,
  appliedFilters,
  onClearAllProductReviewFilters,
  toggleAppliedProductReviewFilter,
  activeKeyword,
  setActiveKeyword,
}: {
  appliedFilters: AppliedReviewFilter[];
  filters: ReviewFilter[];
  onClearAllProductReviewFilters: () => void;
  toggleAppliedProductReviewFilter: (
    appliedFilters: AppliedReviewFilter[],
    key: string,
    value: string,
    checked: boolean
  ) => void;
  activeKeyword: string | undefined;
  setActiveKeyword: React.Dispatch<React.SetStateAction<string | undefined>>;
}) => {
  return appliedFilters.length > 0 || activeKeyword ? (
    <ul className={styles.appliedReviewFilters}>
      {appliedFilters.map((appliedFilter) => {
        const availableFilter = filters.find((filter) => filter.filtertype.label === appliedFilter.key);
        return appliedFilter.values.map((value) => {
          const filterOption = availableFilter?.filteroptions.find((filteroption) => {
            return value.includes(filteroption.key);
          });
          return filterOption ? (
            <li className={styles.appliedReviewFiltersPills} key={`${filterOption.key}${value}`}>
              <span className="banner underline">{filterOption.display_value}</span>
              <span
                className="alo-cross-primary-icon"
                onClick={() => toggleAppliedProductReviewFilter(appliedFilters, appliedFilter.key, value, false)}
              ></span>
            </li>
          ) : null;
        });
      })}
      {activeKeyword ? (
        <li className={styles.appliedReviewFiltersPills} key={activeKeyword}>
          <span className="banner underline">{activeKeyword}</span>
          <span className="alo-cross-primary-icon" onClick={() => setActiveKeyword(undefined)}></span>
        </li>
      ) : null}
      <li
        className={`${styles.appliedReviewFiltersPills} ${styles.clearAllAppliedReviewFilters}`}
        onClick={() => onClearAllProductReviewFilters()}
      >
        Clear All
      </li>
    </ul>
  ) : null;
};

export default AppliedProductReviewFilters;
